export default __webpack_public_path__ + "static/media/AssassinLogoBlack.9d452faa.png";